var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from 'react';
import classNames from 'classnames';
import { CheckboxColor, CheckboxColorContent, CheckboxContainer, CheckboxIcon, CheckboxInput, CheckboxLabelBasic, CheckboxSize, CheckboxSizeText, } from './styles/checkbox.styled';
/**
 * The progress component can be used to display form progress
 */
const Checkbox = (_a) => {
    var { variant = 'basic', reference, name, label, tooltip, required = false, disabled = false, valid, value, inputRef, class: className, dataTest = 'checkbox' } = _a, props = __rest(_a, ["variant", "reference", "name", "label", "tooltip", "required", "disabled", "valid", "value", "inputRef", "class", "dataTest"]);
    const checkboxClassName = classNames('PONCHO-checkbox', {
        'PONCHO-checkbox--size': variant === 'size',
        'PONCHO-checkbox--size-wide': variant === 'size' && value && value.length > 3,
        'PONCHO-checkbox--color': variant === 'color',
        'PONCHO-checkbox--valid': valid === true,
        'PONCHO-checkbox--invalid': valid === false,
    }, className);
    useEffect(() => {
        if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.warn(`DEPRECATION WARNING: Checkbox from '@anwb/checkbox' is deprecated. Please use Checkbox from '@anwb/forms'.`);
        }
    }, []);
    return (React.createElement(CheckboxContainer, { className: checkboxClassName, htmlFor: reference, id: `${reference || ''}-label`, "data-hj-suppress": true, "data-test": dataTest, "$variant": variant },
        React.createElement(CheckboxInput, Object.assign({ id: reference, name: name, required: required, disabled: disabled, "aria-disabled": disabled, "aria-invalid": valid === false ? true : undefined, className: "PONCHO-checkbox__input", ref: inputRef, value: value, "data-test": `${dataTest}-input`, "$isInvalid": valid === false }, props)),
        variant === 'basic' && (React.createElement(CheckboxLabelBasic, { className: "PONCHO-checkbox__label", dataTest: `${dataTest}-label`, tagName: "span" },
            label,
            tooltip,
            React.createElement(CheckboxIcon, null))),
        variant === 'size' && (React.createElement(CheckboxSize, { className: "PONCHO-checkbox__content", "data-test": `${dataTest}-content` },
            React.createElement(CheckboxSizeText, { dataTest: `${dataTest}-label-size`, tagName: "span" }, value && value.toUpperCase()))),
        variant === 'color' && (React.createElement(CheckboxColor, { className: "PONCHO-checkbox__content", "data-test": `${dataTest}-label-color` },
            React.createElement(CheckboxColorContent, { "$value": value })))));
};
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map